import { render } from "./QuickRepliesView.vue?vue&type=template&id=4f8cb1b6&scoped=true"
import script from "./QuickRepliesView.vue?vue&type=script&lang=js"
export * from "./QuickRepliesView.vue?vue&type=script&lang=js"

import "./QuickRepliesView.vue?vue&type=style&index=0&id=4f8cb1b6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f8cb1b6"]])

export default __exports__